import AppSimpleBar from "components/AppSimpleBar";
import { Utils } from "helpers/utils";
import { useRedux } from "hooks";
import React, { forwardRef, useEffect, useState } from "react";

import { Input } from "reactstrap";
import { createSelector } from "reselect";
import { setTypingTag } from "../../../../redux/actions";
import { Const } from "const";

interface InputSectionProps {
  value: null | string;
  onChange: (value: string) => void;
  onKeyDown: (event: any) => void;
  onPaste: (event: any) => void;
  rowCount: number;
}

// const InputSection = ({ value, onChange, onKeyDown }: InputSectionProps) => {
const InputSection = forwardRef<HTMLTextAreaElement, InputSectionProps>(({ value, onChange, onKeyDown, onPaste, rowCount }, ref) => {

  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Chats,
    (state: any) => state.Profile2,
    (chats, p2) => ({
      members: chats.chatUserDetails.members,
      selectedChat: chats.selectedChat,
      currentUserId: p2.userId
    })
  );
  const { members, selectedChat, currentUserId } = useAppSelector(storeData);

  // const [message, setMessage] = useState<string>("");
  // const [message, setMessage] = useState<string>(''); // State to hold message
  const [isDropdownVisible, setIsDropdownVisible] = useState<boolean>(false);
  const [tagNameDropDownHeight, setTagNameDropDownHeight] = useState<number>(200);
  const [filteredNames, setFilteredNames] = useState<any[]>([]); // Names filtered by user input
  const [cursorPosition, setCursorPosition] = useState<number>(0); // Cursor position where @ was typed
  const [dropdownPosition, setDropdownPosition] = useState<{ top: number; left: number }>({
    top: 0,
    left: 0,
  }); // Dropdown position  

  useEffect(()=>{
    setIsDropdownVisible(false);
  }, [selectedChat]);

  const tagNameHeight = 32;
  const taxMaxNameShow = 5;

  const [assignIndex, setAssignIndex] = useState<number>(-1);

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newMessage = event.target.value;
    // setMessage(newMessage);

    // Find the position of @ symbol and trigger the dropdown logic
    const caretPosition = event.target.selectionStart;
    const inputBeforeCaret = newMessage.slice(0, caretPosition);
    // console.log({ newMessage, caretPosition, inputBeforeCaret });
    const lastAtIndex = inputBeforeCaret.lastIndexOf("@");
    // console.log({newMessage, caretPosition, inputBeforeCaret, lastAtIndex});

    const atIndex = lastAtIndex;
    if (atIndex !== -1) {
      // Filter names based on what follows the @ symbol
      // const query = newMessage.slice(atIndex + 1);
      const query = inputBeforeCaret.slice(lastAtIndex + 1).trim();
      //const filtered = names.filter((name) => name.toLowerCase().includes(query.toLowerCase()));
      // console.log('x:', members, currentUserId);
      const filtered = members.filter((ee: any) => ee.id != currentUserId && ee.nameForShow.toLowerCase().includes(query.toLowerCase()));
      if (query === "") {
        filtered.unshift({ nameForShow: "ทุกคน...", id: -1 }); // Assuming the object structure matches your requirements
      }

      setFilteredNames(filtered);
      if (filtered.length > 0) {
        setIsDropdownVisible(true);
        // setFilteredNames(names.filter((name) => name.toLowerCase().includes(query.toLowerCase())));

        // Position the dropdown above the textarea
        const totalHeight = Math.min(taxMaxNameShow, filtered.length) * tagNameHeight;
        setTagNameDropDownHeight(totalHeight);

        if (ref && 'current' in ref && ref.current) {
          const rect = ref.current.getBoundingClientRect();
          // console.log(rect);
          // setDropdownPosition({
          //   top: rect.top - 40, // Adjust to place the dropdown above
          //   left: rect.left,
          // });

          setDropdownPosition({
            top: 0 - totalHeight,
            left: 0,
          });
        }
      } else {
        setIsDropdownVisible(false);
      }
    } else {
      setIsDropdownVisible(false);
    }
  };

  const handleNameClick = (id: any, name: string) => {
    const replaceLastAtWithPersonName = (input: string, tagName: string, caretPos: number): string => {
      // Ensure caretPos is within valid bounds
      if (caretPos < 0 || caretPos > input.length) {
        throw new Error("Invalid caret position");
      }

      // Extract the portion of the string before the caret position
      const beforeCaret = input.substring(0, caretPos);

      // Find the last `@` before the caret position
      const lastAtIndex = beforeCaret.lastIndexOf("@");

      // If no `@` is found, return the original input
      if (lastAtIndex === -1) {
        return input;
      }

      // Replace from the last `@` to the caret position with `@tagName`
      const updatedBeforeCaret =
        beforeCaret.substring(0, lastAtIndex) + "@" + tagName;

      // Combine with the portion of the string after the caret position
      const afterCaret = input.substring(caretPos);

      return updatedBeforeCaret + afterCaret + ' ';
      // Use a regular expression to find the last @ and the following text up to a space or the end of the string
      //return input.replace(/@[^ ]*$/, "@" + tagName) + " ";//"@person name");
    }

    const message = (ref && 'current' in ref && ref.current) ? ref.current.value : '';
    // console.log(message, name);
    // Insert the selected name into the message at the cursor position
    // console.log('tag: ' + id + ':' + name);
    const charPos = (ref && 'current' in ref && ref.current) ? ref.current.selectionStart : -1;
    const newMessage = replaceLastAtWithPersonName(message, name, charPos);//  `${message.slice(0, cursorPosition)}@${name} ${message.slice(cursorPosition + 1)}`;
    // console.log({message, newMessage});
    onChange(newMessage);
    dispatch(setTypingTag(selectedChat, id + Const.DELIM_VALUE + "@" + name));
    if ((ref && 'current' in ref && ref.current)) {
      ref.current.focus();
    }
    // setMessage(newMessage);
    setIsDropdownVisible(false); // Hide the dropdown after selection
    setFilteredNames([]); // Clear the filtered names
  };

  // console.log("value",value)
  return (
    <div className="position-relative">
      <textarea
        ref={ref}
        className="form-control form-control-lg chat-input"
        id="chat-input"
        rows={rowCount}
        placeholder="พิมพ์ข้อความ...."
        title="ข้อความมากสุด 500 ตัวอักษร..."
        value={value || ""}
        onKeyDown={(e: any) => onKeyDown(e)}
        onPaste={(e: any) => onPaste(e)}
        onChange={(e: any) => {
          handleChange(e);
          onChange(e.target.value);
        }}
        autoComplete="off"
      />

      {/* Dropdown to show filtered names after typing @ */}
      {isDropdownVisible && filteredNames.length > 0 && (
        <div className="tag-name-container-div">
          <AppSimpleBar
            className={"tag-name-container " + Utils.GetCssSuffixTheme("tag-name-container")}
            style={{
              top: dropdownPosition.top,
              left: dropdownPosition.left,
              maxHeight: tagNameDropDownHeight + 'px',
              minHeight: tagNameDropDownHeight + 'px',
            }}
          >
            <ul style={{ listStyle: "none", paddingLeft: "0px" }}>
              {filteredNames.map((name) => (
                <li
                  key={name.id}
                  style={{
                    padding: '5px 10px',
                    minHeight: tagNameHeight + 'px',
                    maxHeight: tagNameHeight + 'px',
                    cursor: 'pointer',
                    // backgroundColor: '#f5f5f5',
                    // borderBottom: '1px solid #ddd',
                  }}
                  onClick={() => handleNameClick(name.id, name.nameForShow)}
                >
                  {name.nameForShow}
                </li>
              ))}
            </ul>
          </AppSimpleBar>
        </div>
      )}

    </div>
  );
});
export default InputSection;
